module.exports = __webpack_public_path__ + "static/media/Yay.88d2990c.png";